import { client } from "../libs/client";

// Authentication
export const adminLogin = async (data) => {
  return await client.post("/admin/login", data);
};

// Dashboard
export const getDashboardStats = async (params) => {
  return await client.get("/admin/dashboard/stats", { params });
};

export const getDashboardUsersCount = async (params) => {
  return await client.get("/admin/dashboard/users-count", { params });
};

export const getDashboardWillsCount = async (params) => {
  return await client.get("/admin/dashboard/wills-count", { params });
};

export const getDashboardActiveUsers = async (params) => {
  return await client.get("/admin/dashboard/active-users", { params });
};

// User Management
export const getAdminUsers = async (params) => {
  return await client.get("/admin/users", { params });
};

export const getAdminSubscribers = async () => {
  return await client.get("/admin/subscribe");
};

export const getAdminUserDetails = async (userId) => {
  return await client.get(`/admin/users/${userId}`);
};

export const getPendingDeletionUsers = async (params) => {
  return await client.get("/admin/users/pending-deletion", { params });
};

export const updateAdminUserStatus = async ({ userId, data }) => {
  return await client.patch(`/admin/users/${userId}/status`, data);
};

export const markAdminUserEmailVerified = async (userId) => {
  return await client.post(`/admin/users/${userId}/verify-email`);
};

export const resendAdminUserVerification = async (userId) => {
  return await client.post(`/admin/users/${userId}/resend-verification`);
};

export const sendAdminUserPasswordReset = async (userId) => {
  return await client.post(`/admin/users/${userId}/password-reset`);
};

export const cancelAdminUserDeletion = async (userId) => {
  return await client.post(`/admin/users/${userId}/cancel-deletion`);
};

export const deleteAdminUser = async (userId) => {
  return await client.delete(`/admin/users/${userId}`);
};

export const updateAdminUser = async ({ userId, data }) => {
  return await client.patch(`/admin/users/${userId}`, data);
};

export const impersonateAdminUser = async (userId) => {
  return await client.post(`/admin/users/${userId}/impersonate`);
};

// Administrator Management
export const getAdministrators = async () => {
  return await client.get("/admin/administrators");
};

export const createAdministrator = async (data) => {
  return await client.post("/admin/administrators", data);
};

export const deleteAdministrator = async (adminId) => {
  return await client.delete(`/admin/administrators/${adminId}`);
};

// Plan Management
export const getPlanStatistics = async () => {
  return await client.get("/admin/plans/statistics");
};

export const getAdminPlans = async (params) => {
  return await client.get("/admin/plans", { params });
};

export const getAdminPlanDetails = async (planId) => {
  return await client.get(`/admin/plans/${planId}`);
};

export const createAdminPlan = async (data) => {
  return await client.post("/admin/plans", data);
};

export const updateAdminPlan = async (planId, data) => {
  return await client.patch(`/admin/plans/${planId}`, data);
};

export const toggleAdminPlanStatus = async (planId) => {
  return await client.patch(`/admin/plans/${planId}/toggle-status`);
};

export const deleteAdminPlan = async (planId) => {
  return await client.delete(`/admin/plans/${planId}`);
};

// Will Management
export const getAdminWills = async (params) => {
  return await client.get("/admin/wills", { params });
};

export const getAdminWillDetails = async (willId) => {
  return await client.get(`/admin/wills/${willId}`);
};

export const generateAdminWillPdf = async (willId) => {
  return await client.post(`/admin/wills/${willId}/generate`);
};

// Designation Management
export const getAdminDesignations = async (params) => {
  return await client.get("/admin/designations", { params });
};

export const resendDesignationInvite = async (id) => {
  return await client.post(`/admin/designations/${id}/resend`);
};

export const overrideDesignationStatus = async (id, data) => {
  return await client.patch(`/admin/designations/${id}/override`, data);
};

// Transaction Management
export const getAdminTransactions = async (params) => {
  return await client.get("/admin/transactions", { params });
};

// Contact Messages
export const getAdminContactMessages = async (params) => {
  return await client.get("/admin/contact-us", { params });
};

// Exports
export const exportAdminData = async ({ type, params }) => {
  return await client.get(`/admin/exports/${type}`, { params });
};

// Audit Logs
export const getAdminAuditLogs = async (params) => {
  return await client.get("/admin/audit-logs", { params });
};
